import { render, staticRenderFns } from "./DomainMedia.vue?vue&type=template&id=ad1a84c0&"
import script from "./DomainMedia.vue?vue&type=script&lang=js&"
export * from "./DomainMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports